import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";
export default function CookiePolicy() {
  return <LegalPageLayout tKey="cookies" />;
}
